import { CaseState } from 'app/area/case/types-store';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';

/**
 * The data of the report row the component is rendered for. Only available in report mode.
 */
export const reportRow = (caseState: CaseState, uiEngineProps: any) => ({
  reportRow: getCaseData(caseState, uiEngineProps) as any
});
